import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Redirects to /login if user is not authenticated
 */
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const isAuthenticated = auth.isAuthenticated();
  console.log('Auth Guard:', { isAuthenticated });
  if (isAuthenticated) return true;
  const router = inject(Router);
  return router.createUrlTree(['/login']);
};
